import * as React from "react";
import { useNavigate } from "react-router-dom";
import EnterIcon from '../../../utils/media/icons/enter.png';
import Chip from "../../../components/Chip";

function ChallengeWiseSubmissionTable({ data, toast, isLoading }) {

    const navigate = useNavigate();

    // const toggleSelectAll = () => {
    //     if (selectedRows.size === data.length) {
    //         setSelectedRows(new Set());
    //     } else {
    //         setSelectedRows(new Set(data.map(user => user._id)));
    //     }
    // };

    // const toggleSelectRow = (id) => {
    //     const newSelected = new Set(selectedRows);
    //     if (newSelected.has(id)) {
    //         newSelected.delete(id);
    //     } else {
    //         newSelected.add(id);
    //     }
    //     setSelectedRows(newSelected);
    // };

    const handleEdit = (id) => {
        // if(userType === 'regular') navigate('/user/edit/user', { state: { _id: id }});
        // else if(userType === 'ambassador') navigate('/user/edit/ambassador', { state: { _id: id }});
        // else if(userType === 'Company') navigate('/user/edit/company', { state: { _id: id }});
        // else if(userType === 'NGO') navigate('/user/edit/ngo', { state: { _id: id }});
        navigate('/submissions/challenge-submission-details', { state: { _id: id } });
    }

    // const handleDelete = (id) => {
    //     const con = window.confirm('Are you sure you want to delete this user?');
    //     // con && deleteUser(id, toast);
    // }

    const renderStatusChips = (status) => {
        switch (status) {
            case 'pending':
                return <Chip value={status} color="inactive" />;
            case 'rejected':
                return <Chip value={status} color="red" />;
            case 'submitted':
                return <Chip value={'accepted'} color="green" />;
        }
    }

    if (isLoading) {
        return (
            <div className="w-full h-96 flex items-center justify-center">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }

    if (!isLoading && data.length === 0) {
        return (
            <div className="w-full h-96 flex items-center justify-center">
                <h1 className="text-xl text-gray-400">No Submission Found!</h1>
            </div>
        );
    }

    return (
        <div className="overflow-x-scroll mt-2">
            <table className="w-full border-collapse text-base" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        {/* <th className="p-2 text-left">
                            <input
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 accent-primary"
                                checked={selectedRows.size === data.length}
                                onChange={toggleSelectAll}
                                aria-label="Select all data"
                            />
                        </th> */}
                        <th className="p-2 text-left">Srl. No.</th>
                        {/* <th className="p-2 text-left">Category</th> */}
                        <th className="p-2 text-left">Challenge Name</th>
                        <th className="p-2 text-left">Submitted By</th>
                        <th className="p-2 text-center">Submitted On</th>
                        <th className="p-2 text-center">Status</th>
                        <th className="p-2 text-center">Total Challenge Points</th>
                        <th className="p-2 text-center">Allocated Submission Points</th>
                        {/* <th className="p-2 text-center">Allocated Earned Challenge Points</th> */}
                        <th className="p-2 text-center">Allocated Bonus Points</th>
                        {/* <th className="p-2 text-center">Allocated Earned Bonus Points</th> */}
                        <th className="p-2 text-center">Allocated Carbon Saving Points</th>
                        {/* <th className="p-2 text-center">Actual Carbon Saving Points</th> */}
                        <th className="p-2 text-center">Challenge of the day Points</th>
                        {/* <th className="p-2 text-center">Allocated Challenge of the day Points</th> */}
                        <th className="p-2 text-center">Challenge referral Points</th>
                        {/* <th className="p-2 text-center">Allocated Challenge referral Points</th> */}
                        <th className="p-2 text-center">Total Allocated Points</th>
                        <th className="p-2 text-center">Carbon Savings</th>
                        <th className="p-2 text-left">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, id) => (
                        <tr key={item._id || `${item.user?._id}-${item.challenge?._id}-${id}`}
                            className="border-b border-navBtn hover:bg-gray-50"
                        >
                            {/* <td className="p-2">
                                <input
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 accent-primary mt-1"
                                checked={selectedRows.has(item._id)}
                                onChange={() => toggleSelectRow(item._id)}
                                aria-label={`Select ${item.name}`}
                                />
                                </td> */}
                            <td className="p-2">{++id}</td>
                            {/* <td className="p-2">{item?.challenge?.category?.name ?? '-'}</td> */}
                            <td className="p-2 flex flex-col">
                                {
                                    item?.challenge?.isSponsored && (
                                        <div>
                                            <Chip value="Sponsored" color="blue" small={true} />
                                        </div>
                                    )
                                }
                                {item?.challenge?.name ?? '-'}
                            </td>
                            <td className="p-2">{item?.user ? item?.user?.name?.firstName + " " + item.user?.name?.lastName : "-"}</td>
                            <td className="p-2">{new Date(item?.submission?.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                            <td className="p-2 text-sm capitalize">{renderStatusChips(item?.submission?.reviewStatus)}</td>
                            {/* total points */}
                            <td className="p-2 text-center">
                                {
                                    (item?.challenge?.points + // challenge points
                                        item?.challenge?.bonusPoints + // challenge bonus points
                                        (item?.challenge?.carbonSavingPoints || 0)) + // projected carbon saving points
                                    (item?.submission?.isChallengeOfTheDay ? item?.challenge?.challengeOfTheDayPoints : 0) + // challenge of the day points (if it was challenge of the day at the time of user submission)
                                    (item?.submission?.allocatedChallengeReferralPoints ?? 0) // challenge referral points
                                    || 0
                                }
                            </td>
                            {/* challenge points */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {item?.submission?.allocatedPoints}
                                </p>
                                <small className="text-secondary text-base">
                                    (out of {item?.challenge?.points || 0})
                                </small>
                            </td>
                            {/* allocated challenge points */}
                            {/* <td className="p-2 text-nowrap text-center">{item?.submission?.allocatedPoints}</td> */}
                            {/* challenge bonus points */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {item?.submission?.allocatedBonusPoints || 0}
                                </p>
                                <small className="text-secondary text-base">
                                    (out of {item?.challenge?.bonusPoints || 0})
                                </small>
                            </td>
                            {/* allocated bonus points */}
                            {/* <td className="p-2 text-nowrap text-center">{item?.submission?.allocatedBonusPoints || 0}</td> */}
                            {/* challenge carbon saving points */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {(item?.submission?.actualCarbonSavingPoints) || 0}
                                </p>
                                <small className="text-secondary text-base">
                                    (out of {item?.challenge?.carbonSavingPoints || 0})
                                </small>
                            </td>
                            {/* allocated carbon saving points */}
                            {/* <td className="p-2 text-nowrap text-center">{(item?.submission?.actualCarbonSavingPoints) || 0}</td> */}
                            {/* challenge of the day */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {(item?.submission?.isChallengeOfTheDay ? item?.submission?.allocatedChallengeOfTheDayPoints : 0)}
                                </p>
                            </td>
                            {/* allocated challenge of the day */}
                            {/* <td className="p-2 text-nowrap text-center">{(item?.submission?.isChallengeOfTheDay ? item?.submission?.allocatedChallengeOfTheDayPoints : 0)}</td> */}
                            {/* challenge referral */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {(item?.submission?.isInvited ? item?.submission?.allocatedChallengeReferralPoints : 0)}
                                </p>
                            </td>
                            {/* allocated referral */}
                            {/* <td className="p-2 text-nowrap text-center">{(item?.submission?.isInvited ? item?.submission?.allocatedChallengeReferralPoints : 0)}</td> */}
                            {/* total allocated points */}
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {item?.submission?.allocatedPoints + item?.submission?.allocatedBonusPoints + item?.submission?.actualCarbonSavingPoints + (item?.submission?.isChallengeOfTheDay ? item?.submission?.allocatedChallengeOfTheDayPoints : 0) + (item?.submission?.isInvited ? item?.submission?.allocatedChallengeReferralPoints : 0) || 0}
                                </p>
                            </td>
                            <td className="p-2 text-nowrap text-center">
                                <p>
                                    {item?.submission?.carbonEmissionCount ?? 0}
                                </p>
                            </td>
                            <td className="p-2">
                                <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] min-h-7 mr-1" onClick={() => handleEdit(item.submission._id)}>
                                    <img src={EnterIcon} alt="edit" className="w-6" />
                                </button>
                                {/* <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7" onClick={() => navigate('/user/view/user', { state: { _id: user._id } })}>
                                    <img src={ViewIcon} alt="view" />
                                </button> */}
                                {/* <button className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 ml-1 px-2" onClick={() => handleDelete(item._id, item.userType)}>
                                    <img src={DeleteIcon} alt="delete" />
                                </button> */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ChallengeWiseSubmissionTable;